(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function start(root) {
    if (!root || root.dataset.dpReady === '1') return;
    root.dataset.dpReady = '1';

    var track = root.querySelector('[data-greviews-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-greviews-slide]'));
    var dotsWrap = root.querySelector('[data-greviews-dots]');
    var prev = root.querySelector('[data-greviews-prev]');
    var next = root.querySelector('[data-greviews-next]');
    if (!track || slides.length < 2) return;

    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var index = 0;

    /* Hoeveel kaarten passen er naast elkaar? Bepaalt hoe ver we kunnen. */
    function zichtbaar() {
      var breedte = slides[0].getBoundingClientRect().width;
      if (!breedte) return 1;
      return Math.max(1, Math.round(track.clientWidth / breedte));
    }
    function laatste() {
      return Math.max(0, slides.length - zichtbaar());
    }

    function ga(naar) {
      index = naar;
      if (index > laatste()) index = 0;
      if (index < 0) index = laatste();
      track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: rustig ? 'auto' : 'smooth' });
      tekenDots();
    }

    /* Stippen */
    var dots = [];
    function bouwDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i <= laatste(); i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'greviews__dot';
          b.setAttribute('aria-label', 'Ga naar review ' + (i + 1));
          b.addEventListener('click', function () { pauzeer(); ga(i); hervat(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
      tekenDots();
    }
    function tekenDots() {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    /* Automatisch doorschuiven */
    function hervat() {
      if (!interval || rustig) return;
      pauzeer();
      timer = setInterval(function () { ga(index + 1); }, interval * 1000);
    }
    function pauzeer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { pauzeer(); ga(index - 1); hervat(); });
    if (next) next.addEventListener('click', function () { pauzeer(); ga(index + 1); hervat(); });

    /* Stil houden zolang iemand kijkt, sleept of met toetsen navigeert */
    root.addEventListener('mouseenter', pauzeer);
    root.addEventListener('mouseleave', hervat);
    root.addEventListener('focusin', pauzeer);
    root.addEventListener('focusout', hervat);
    track.addEventListener('pointerdown', pauzeer);
    track.addEventListener('touchstart', pauzeer, { passive: true });

    /* Zelf swipen: bijhouden waar we zijn zonder tegen te werken */
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var links = track.scrollLeft;
        var dichtst = 0, besteAfstand = Infinity;
        slides.forEach(function (s, i) {
          var afstand = Math.abs((s.offsetLeft - slides[0].offsetLeft) - links);
          if (afstand < besteAfstand) { besteAfstand = afstand; dichtst = i; }
        });
        index = Math.min(dichtst, laatste());
        tekenDots();
      }, 120);
    }, { passive: true });

    /* Niet doorschuiven als de sectie niet in beeld is */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? hervat() : pauzeer(); });
      }, { threshold: 0.2 }).observe(root);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(bouwDots, 200);
    });

    bouwDots();
    hervat();
  }

  function initAlles(scope) {
    (scope || document).querySelectorAll('[data-greviews]').forEach(start);
  }

  document.addEventListener('DOMContentLoaded', function () { initAlles(); });
  document.addEventListener('shopify:section:load', function (e) { initAlles(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
